import {
  AirlineData,
} from '@refx/e2e';

const testAirline: Record<string, AirlineData> = {
  Test6X: {
    sap: '1ASIXJCP',
    oid: 'NCE6X0100',
    airlineCode: '6X',
    apiKey: 'eyJnYXRld2F5Q2xpZW50SWQiOiJoSFRHV0hGRGVVRlZkT3p0UVdUQzd6b2U2M0Uwazh6dSIsImdhdGV3YXlDbGllbnRTZWNyZXQiOiJadzJxZUw5cTJMWGQ2RXowIn0'
  },
  Test6XUAT: {
    sap: '1ASIXJCPU',
    oid: 'NCE6X0100',
    airlineCode: '6X',
    apiKey: 'eyJnYXRld2F5Q2xpZW50SWQiOiJwQW9Oa2ZtRDBrQkw5N2NINnlxcTFhOEFqaVc3UmxxRCIsImdhdGV3YXlDbGllbnRTZWNyZXQiOiJXeTJkeDI3VTAzN1o4cndjIn0='
  },
  Test7XUAT: {
    sap: '1ASIXJCPU',
    oid: 'NCE6x0980',
    airlineCode: '7X',
    apiKey: 'eyJnYXRld2F5Q2xpZW50SWQiOiJ6Q2RqaDA5NlVjbXU1bmpJcVh5SWVEeVVxWUNzb3BYbCIsImdhdGV3YXlDbGllbnRTZWNyZXQiOiJ2ZkpJRGNqWFZtcUdSUDFSIn0'
  },
  Test7XPDT: {
    sap: '1ASIXJCP',
    oid: 'NCE6x0980',
    airlineCode: '7X',
    apiKey: 'eyJnYXRld2F5Q2xpZW50SWQiOiJHckp1OFRnOGNHejNzMzZaazFCNDdFYWJJek5jelVIUCIsImdhdGV3YXlDbGllbnRTZWNyZXQiOiJpV0F6ang2SDFabWljdzJEIn0'
  },
  TestAV: {
    sap: '1ASIXJCP',
    oid: 'BOGAV08LV',
    airlineCode: 'AV',

    apiKey: 'eyJnYXRld2F5QmFzZVVybCI6Imh0dHBzOi8vdGVzdC5hdmlhbmNhLmFpcmxpbmVzLmFwaS5hbWFkZXVzLmNvbSIsImdhdGV3YXlDbGllbnRJZCI6Ik5pNm14aDhuT05XajV1d3FZWTJtQ1I5TmNuWmhad2JsIiwiZ2F0ZXdheUNsaWVudFNlY3JldCI6IkkyQXdHQlI2Mm9teHgweVkifQ=='
  },
  TestSV: {
    sap: '1ASIXJCP',
    oid: 'JEDSV08AD',
    airlineCode: 'SV',

    apiKey: 'eyJnYXRld2F5QmFzZVVybCI6Imh0dHBzOi8vdGVzdC5zYXVkaWEuYWlybGluZXMuYXBpLmFtYWRldXMuY29tIiwiZ2F0ZXdheUNsaWVudElkIjoiV21Wd3dsRW5Eajh2ZnlBaVF2OXlpejdLeXpXQXB0aDQiLCJnYXRld2F5Q2xpZW50U2VjcmV0Ijoidk9neUo1M25DbjNRQXFkMyJ9'
  },
  TestUX: {
    sap: '1ASIXJCPU',
    oid: 'PMIUX08AF',
    airlineCode: 'UX',

    apiKey: 'eyJnYXRld2F5QmFzZVVybCI6Imh0dHBzOi8vdGVzdC5haXJldXJvcGEuYWlybGluZXMuYXBpLmFtYWRldXMuY29tIiwiZ2F0ZXdheUNsaWVudElkIjoieHRGREdtQ3hkeklLaW9HUXA3THpuR0p1OE5xZ2xYbngiLCJnYXRld2F5Q2xpZW50U2VjcmV0IjoiN3ROVnYyZU5xUnRuSWJPeCJ9'
  }
};

export const test6x = testAirline.Test6X;
export const test6xUat = testAirline.Test6XUAT;
export const test7xPdt = testAirline.Test7XPDT;
export const test7xUat = testAirline.Test7XUAT;
export const testAv = testAirline.TestAV;
export const testSv = testAirline.TestSV;
export const testUx = testAirline.TestUX;
